import React from 'react';
import PropTypes from 'prop-types';

import { withContainer } from 'core/cache';

import { getMockChallenges } from '../helpers/getMockData';

import ProfileChallenges from '../components/profileChallenges';

const ProfileChallengesContainer = ({ profileChallenges, profile, user }) => {
  const isCurrentUser = user.data.id === profile.data.id;
  const isLoading = profileChallenges.status === 'loading';

  return (
    <ProfileChallenges
      data={profileChallenges.data}
      isCurrentUser={isCurrentUser}
      isLoading={isLoading}
      trophiesCount={profile.data.trophies_count}
    />
  );
};

ProfileChallengesContainer.propTypes = {
  profileChallenges: PropTypes.shape({
    status: PropTypes.string,
    data: PropTypes.shape({
      active: PropTypes.arrayOf(
        PropTypes.shape({
          challenge_id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          challenge_picture: PropTypes.shape({
            w96: PropTypes.string.isRequired,
          }).isRequired,
        })
      ),
      completed: PropTypes.arrayOf(
        PropTypes.shape({
          challenge_id: PropTypes.number.isRequired,
          name: PropTypes.string.isRequired,
          challenge_picture: PropTypes.shape({
            w96: PropTypes.string.isRequired,
          }).isRequired,
        })
      ),
    }),
  }).isRequired,
  profile: PropTypes.shape({
    data: PropTypes.shape({
      id: PropTypes.number,
      trophies_count: PropTypes.number,
    }),
  }).isRequired,
  user: PropTypes.shape({
    data: PropTypes.shape({
      id: PropTypes.number,
    }),
  }).isRequired,
};

export default withContainer(ProfileChallengesContainer, {
  cache: {
    profileChallenges: {
      getMockedResponse: () => ({ data: getMockChallenges() }),
      getParams: ({ props }) => {
        if (props.match) {
          const { params } = props.match;
          if (params.id) {
            return {
              profileUrl: params.id,
            };
          }
        }
      },
      initialData: {},
      isMocked: false,
      transform: ({ data }) => data.data,
      url: '/api/learner/joined_challenges?profile_url=:profileUrl',
    },
    profile: { isListener: true },
    user: { isListener: true },
  },
  hasRouter: true,
});
